import { render, staticRenderFns } from "./AddContractorToCompanyNew.vue?vue&type=template&id=eb183bba"
import script from "./AddContractorToCompanyNew.vue?vue&type=script&lang=ts"
export * from "./AddContractorToCompanyNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb183bba')) {
      api.createRecord('eb183bba', component.options)
    } else {
      api.reload('eb183bba', component.options)
    }
    module.hot.accept("./AddContractorToCompanyNew.vue?vue&type=template&id=eb183bba", function () {
      api.rerender('eb183bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/AddContractorToCompanyNew.vue"
export default component.exports